export const EXTRACT_REQUEST_STARTED = 'EXTRACT_REQUEST_STARTED';
export const EXTRACT_REQUEST_SUCCESS = 'EXTRACT_REQUEST_SUCCESS';
export const EXTRACT_REQUEST_FAILURE = 'EXTRACT_REQUEST_FAILURE';
